import { createListenerMiddleware, type TypedAddListener, type TypedStartListening } from '@reduxjs/toolkit';
import { TLogLevelsIndexedDB } from '@th-common/enums/indexed-db/log-level';
import { addLog } from '@th-common/utils/indexed-db/logs';

import type { AppDispatch, RootState } from '../store';

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;
export type AppAddListener = TypedAddListener<RootState, AppDispatch>;

export const apiLoggerMiddleware = createListenerMiddleware();

export const startAppListening = apiLoggerMiddleware.startListening as AppStartListening;

startAppListening({
  predicate: (action) => {
    return action.type.endsWith('/rejected');
  },

  effect: async (action, listenerApi) => {
    const currentState = listenerApi.getState();

    try {
      const errorDetails = {
        payload: action.payload,
        metaType: (action.meta as any)?.arg.type,
        endpointName: (action.meta as any)?.arg.endpointName,
        fullUrl: window.location.href,
      };

      addLog(TLogLevelsIndexedDB.ERROR, JSON.stringify(errorDetails), currentState);
    } catch (err) {
      console.error('Failed to process rejected action:', err);
    }
  },
});

export default apiLoggerMiddleware;

